import { render, staticRenderFns } from "./mocOnepage.vue?vue&type=template&id=66755c61"
import script from "./mocOnepage.vue?vue&type=script&lang=js"
export * from "./mocOnepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66755c61')) {
      api.createRecord('66755c61', component.options)
    } else {
      api.reload('66755c61', component.options)
    }
    module.hot.accept("./mocOnepage.vue?vue&type=template&id=66755c61", function () {
      api.rerender('66755c61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/mocOnepage.vue"
export default component.exports